import * as React from 'react';
import { Link } from 'react-router-dom';
import {
  CSVUploadInstructions,
  fetchApi,
  FileData,
  getRowsFromRawString,
  identifyErrors,
  notifyError,
  notifyResponse,
  PageTitle,
  ReportUploadStatus,
  Section,
} from 'gossamer-front-end';
import { CSVRow } from 'gossamer-unified';
import { EventUpload, EventUploadRow, eventValidator } from 'cb-model';
import { Alert, Button } from 'react-bootstrap';

export const EventBulkUpload = (): React.JSX.Element => {
  const [rows, setRows] = React.useState<CSVRow<EventUploadRow>[] | null>(null);
  const [errors, setErrors] = React.useState<string[][] | null>(null);
  const [submitting, setSubmitting] = React.useState(false);

  const handleChange = (newValue: string) => {
    setRows([]);
    setErrors([]);
    try {
      const rows = getRowsFromRawString(EventUpload, newValue).map((row) => ({
        type: row.type?.toLowerCase(),
        location_type: row.location_type?.toLowerCase(),
        specialty_group: row.specialty_group?.toLowerCase(),
        employment_grade: row.employment_grade?.toLowerCase(),
        year_group: row.year_group?.toLowerCase(),
        ...row,
      }));
      setRows(rows);
      setErrors(identifyErrors(rows, eventValidator));
    } catch (e) {
      setRows(null);
      setErrors(null);
      notifyError(e, 'An error occurred while reading the CSV file');
    }
  };

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      const eventsToUpload = errors
        .map((error) => error.length === 0)
        .map((valid, index) => (valid ? rows[index] : null))
        .filter((row) => !!row);
      const response = await fetchApi('POST', `/main/bulk-event-create`, {
        events: eventsToUpload,
      });
      notifyResponse(response);
      setRows(null);
      setErrors(null);
    } catch (e) {
      notifyError(e, 'An error occurred while uploading events');
    }
    setSubmitting(false);
  };

  return (
    <>
      <PageTitle title="Bulk Upload Events" subtitle="Using a CSV file as described below" />
      <Section>
        <CSVUploadInstructions entity={EventUpload} />
        <div className="mt-3 mb-3">
          Click <Link to="/admin/event/bulk-upload-prompt-gen">here</Link> to generate a bulk upload prompt for AI.
          Click <Link to="/admin/event/bulk-upload-history">here</Link> to view previous bulk uploads.
        </div>
        <div>
          Choose a CSV file:&nbsp;
          <FileData onChange={handleChange} />
        </div>
      </Section>

      <Section>
        {!!errors && (
          <div>
            <ReportUploadStatus errors={errors} />
            <Button onClick={handleSubmit} disabled={!rows || submitting}>
              Save
            </Button>
          </div>
        )}
      </Section>
    </>
  );
};
